<template>
    <v-container>
        <h3>{{ $t('webboxes.styling.block.title') }}</h3>
        <v-row no-gutters class="pfcl1618818286">
            <v-col class="amber lighten-3 cell" cols="2" /><v-col class="amber lighten-3 cell" cols="3" /><v-col class="amber lighten-3 cell d-flex align-center px-1" cols="2"><v-text-field type="number" dense filled hide-details single-line v-model="mt" /></v-col><v-col class="amber lighten-3 cell" cols="3" /><v-col class="amber lighten-3 cell" cols="2" />
            <v-col class="amber lighten-3 cell" cols="2" /><v-col class="blue lighten-3 cell" cols="3" /><v-col class="blue lighten-3 cell d-flex align-center px-1" cols="2"><v-text-field type="number" dense filled  hide-details single-line v-model="pt" /></v-col><v-col class="blue lighten-3 cell" cols="3" /><v-col class="amber lighten-3 cell" cols="2" />
            <v-col class="amber lighten-3 cell d-flex align-center px-1" cols="2"><v-text-field type="number" dense filled hide-details single-line v-model="ml" /></v-col><v-col class="blue lighten-3 cell d-flex align-center px-1" cols="2"><v-text-field type="number" dense filled  hide-details single-line v-model="pl" /></v-col>
                <v-col class="cell d-flex align-center justify-center" cols="4"><v-btn-toggle dense v-model="locks" multiple rounded><action-button no-icon-attr icon="$lockVertical" :tooltip="$t('webboxes.styling.block.lockv')" /><action-button  no-icon-attr icon="$lockHorizontal" :tooltip="$t('webboxes.styling.block.lockh')" /></v-btn-toggle></v-col>
            <v-col class="blue lighten-3 cell d-flex align-center px-1" cols="2"><v-text-field type="number" dense filled  hide-details single-line v-model="pr" /></v-col><v-col class="amber lighten-3 cell d-flex align-center px-1" cols="2"><v-text-field type="number" dense filled  hide-details single-line v-model="mr" /></v-col>
            <v-col class="amber lighten-3 cell" cols="2" /><v-col class="blue lighten-3 cell" cols="3" /><v-col class="blue lighten-3 cell d-flex align-center px-1" cols="2"><v-text-field type="number" dense filled  hide-details single-line v-model="pb" /></v-col><v-col class="blue lighten-3 cell" cols="3" /><v-col class="amber lighten-3 cell" cols="2" />
            <v-col class="amber lighten-3 cell" cols="2" /><v-col class="amber lighten-3 cell" cols="3" /><v-col class="amber lighten-3 cell d-flex align-center px-1" cols="2"><v-text-field type="number" dense filled  hide-details single-line v-model="mb" /></v-col><v-col class="amber lighten-3 cell" cols="3" /><v-col class="amber lighten-3 cell" cols="2" />
        </v-row>
    </v-container>
</template>
<script>
export default {
    name: 'BlockStyling',
    props: { margin: String, padding: String },
    data() {
        return {
            locks: [0,1],
            indexes: {
                t: 0,
                r: 1,
                b: 2,
                l: 3,
            },
            lockDirections: {
                't': 0,
                'b': 0,
                'l': 1,
                'r': 1
            },
            lockPairs: {
                't': 'b',
                'b': 't',
                'l': 'r',
                'r': 'l'
            },
            fullName: {
                'p': 'padding',
                'm': 'margin'
            }
        }
    },
    watch: {
    },
    computed: {
        parsedp() {
            if(!this.padding) {
                // delfault
                return [0,0,0,0];
            }
            return this.padding.split(' ').map(i => i.replace(/\D/g,''));
        },
        parsedm() {
            if(!this.margin) {
                // delfault
                return [0,0,0,0];
            }
            return this.margin.split(' ').map(i => i.replace(/\D/g,''));
        },
        pt: {
            get() {
                return this.getVal('pt');
            },
            set(val) {
                this.setVal('pt', val);
            }
        },
        mt: {
            get() {
                return this.getVal('mt');
            },
            set(val) {
                this.setVal('mt', val);
            }
        },
        pb: {
            get() {
                return this.getVal('pb');
            },
            set(val) {
                this.setVal('pb', val);
            }
        },
        mb: {
            get() {
                return this.getVal('mb');
            },
            set(val) {
                this.setVal('mb', val);
            }
        },
        pl: {
            get() {
                return this.getVal('pl');
            },
            set(val) {
                this.setVal('pl', val);
            }
        },
        ml: {
            get() {
                return this.getVal('ml');
            },
            set(val) {
                this.setVal('ml', val);
            }
        },
        pr: {
            get() {
                return this.getVal('pr');
            },
            set(val) {
                this.setVal('pr', val);
            }
        },
        mr: {
            get() {
                return this.getVal('mr');
            },
            set(val) {
                this.setVal('mr', val);
            }
        },
    },
    methods: {
        getVal(n) {
            let type = n[0];
            let pos = n[1];
            return this[`parsed${type}`][this.indexes[pos]];
        },
        setVal(n, val) {
            let type = n[0];
            let pos = n[1];
            //console.debug(`Changing value of ${n} to ${val} - type ${type}, pos ${pos}`);
            let posToReplace = null;
            if(this.locks.includes(this.lockDirections[pos])) {
                //console.debug(`Lock active`);
                posToReplace = this.lockPairs[pos];
            }
            //console.debug(`Type to replace: ${posToReplace}`);   
            let output = Object.keys(this.indexes).map(k => k == posToReplace || k == pos ? `${val}px` : `${this[`${type}${k}`]}px`).join(' ');
            this.$emit(`update:${this.fullName[type]}`, output);
        }
    }
}
</script>
<style scoped>
    .cell {
        height: 3em
    }

    input { 
        text-align: right
    }
</style>